// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-J":"J_vanlife-roadtrips-J__LPQea"};